import { render, staticRenderFns } from "./TimeFrameMetric.vue?vue&type=template&id=7595f13e"
import script from "./TimeFrameMetric.vue?vue&type=script&lang=js"
export * from "./TimeFrameMetric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports